import React, { useState } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { Link } from "react-router-dom";

const GNBPURE01004S = () => {

  const [isOpen, setIsOpen] = useState(false); // 드롭다운 메뉴 열림 상태
  const toggleDropdown = (e) => {
    e.preventDefault(); // 기본 동작 방지 (URL 변경 X)
    setIsOpen(!isOpen); // 상태 토글
  };

  return (
    <CommonLayout>
      <CommonMenu />
      <div id="contents" className="container">
        <div className="sub-title bg-type02">
          <h2>사업분야</h2>
        </div>

        <div className="location_wrap">
          <ul className="depth1">
            <li>
              <Link to="/">home</Link>
            </li>
            <li>
              <a href="#none" onClick={toggleDropdown}>
                ASP<span></span>
              </a>
              <ul className="depth2" style={{ display: isOpen ? "block" : "none" }}>
                  <li>
                    <Link to="/GNBPURE01001S">시스템통합(SI)</Link>
                  </li>
                  <li>
                    <Link to="/GNBPURE01002S">시스템유지보수(SM)</Link>
                  </li>
                  <li>
                    <Link to="/GNBPURE01003S">솔루션 제공</Link>
                  </li>
                  <li>
                    <Link to="/GNBPURE01004S">
                      애플리케이션서비스 제공 (ASP)
                    </Link>
                  </li>
                  <li>
                    <Link to="/GNBPURE01005S">IT컨설팅 서비스</Link>
                  </li>
              </ul>
            </li>
          </ul>
        </div>

        <div id="cont" className="cont">
          <div className="inner">
            <h3>
              애플리케이션 서비스 제공
              <br />
              (Application Service Provider, ASP)
            </h3>

            <article>
              <p className="subtitle">GNB & Pure ASP</p>
              <p>
                ASP(Application Service Provider)란 인터넷 환경이 낳은 새로운
                소프트웨어 공급방식으로서, 어플리케이션 소프트웨어를 일괄
                판매하던 과거의 방식과는 달리 소프트웨어를 인터넷 및 클라우드를
                통하여 임대하는 서비스 형태를 말합니다.
              </p>
              <p className="mt20">
                자사의 ASP서비스는 중소형 금융기관 및 기업을 대상으로 이들
                환경을 고려, 자체적으로 구축 할 경우 막대한 비용이 소요되는
                인프라 구축비용을 최소화하여 장비관리부터 유지보수,
                업그레이드까지 직접 운영하여 고객에게 최적의 e-Business환경을
                구축하여 주는 중소형 기관을 위한 전문화된 ASP서비스입니다.
              </p>
            </article>

            <article>
              <p className="subtitle">GNB & Pure ASP Center</p>
              <img src="/asset/img/subB/img_asp.png" alt="asp" className="pc" />
              <img src="/asset/img/subB/img_asp.png" alt="asp" className="mo" />
            </article>

            <div className="table-type table-row mt50">
              <table>
                <caption>ASP</caption>
                <colgroup>
                  <col style={{ width: "25%" }} />
                  <col style={{ width: "75%" }} />
                </colgroup>

                <tbody>
                  <tr>
                    <th scope="row">서비스이용고객</th>
                    <td>
                      <ul className="bul-dot">
                        <li>상호저축은행</li>
                        <li>캐피탈 및 기타여신전문기관</li>
                        <li>카드사 및 보험사</li>
                        <li>중소기업 협회 혹은 단체</li>
                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <th scope="row">제공서비스 종류</th>
                    <td>
                      <ul className="bul-dot">
                        <li>온라인대출시스템</li>
                        <li>무수익채권(NPL) 관리시스템</li>
                        <li>주식매입자금대출(스탁론) 시스템</li>
                        <li>기관중계시스템</li>
                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <th scope="row">특장점</th>
                    <td>
                      <ul className="bul-dot">
                        <li>
                          중소형 금융기관 및 기업 환경에 적합한 특화된 서비스
                          제공으로 수익창출
                        </li>
                        <li>저렴한 비용으로 시스템 구축</li>
                        <li>자사 운영인력 가동으로 24*365 무장애 운영</li>
                        <li>
                          자사의 기술력 있는 인력들에 의한 원활한 유지보수 및
                          신기술 적용
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <CommonFooter />
    </CommonLayout>
  );
};

export default GNBPURE01004S;
